import smallHeaderImage from '../assets/hotspot/headerImages/mehram-s.jpg';
import largeHeaderImage from '../assets/hotspot/headerImages/mehram-l.jpg';
import postcard from '../assets/hotspot/postcardPdf/MehrnamPostcard.pdf';
import postcardThumbnail from '../assets/hotspot/postcardImages/MehrnamPostcardThumbnail.jpg';
import introImage from '../assets/hotspot/intro/Meet_Mehrnam.jpg.jpeg';
import celebrationThumbnail from '../assets/hotspot/celebrationPerformances/Mehrnam_concert.jpg.jpeg';
import bolandBaalaaImage from '../assets/hotspot/celebrationPerformances/mehrnam_boland_baalaa_concert.png';

export const mehram = {
  name: 'Mehrnam',
  headerImages: [smallHeaderImage, largeHeaderImage],
  introVideo: {
    headline: 'Meet Mehrnam, who sings Iranian folk music!',
    details: '',
    vimeoLink: 'https://vimeo.com/1105197690?fl=pl&fe=sh',
    videoImage: introImage,
  },
  concertVideo: {
    videoLink: 'https://vimeo.com/1105196690?fl=pl&fe=sh',
    videoImage: celebrationThumbnail,
  },
  exploreLink: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Mehrnam',
  postCard: {
    pdf: postcard,
    thumbnail: postcardThumbnail,
  },
  lessons: [
    {
      id: 1,
      type: 'audio',
      headline: 'Listen to Mehrnam Sing "Azizam To Golakami"',
      link: 'Learn "Azizam To Golakami"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Mehrnam/Lesson-1',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2138006877&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
    {
      id: 2,
      type: 'audio',
      headline: 'Listen to Mehrnam Sing "Boland Baalaa"',
      link: 'Learn "Boland Baalaa"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Mehrnam/Lesson-2',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2138008515&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
  ],
  traditionBlurb: 'Iranian folk music encompasses a diverse array of regional styles and traditions, reflecting the rich cultural heritage of Iran. These musical traditions often feature intricate melodic patterns, poetic lyrics, and a deep connection to the landscape and history of different regions.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105196690?fl=pl&fe=vl',
      videoImage: celebrationThumbnail,
      songTitle: 'Azizam To Golakami',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Nowruz',
        },
      ],
      songDescription: '"Azizam To Golakami" ("My Dear, My Flower") is a traditional Kurdish folk song that originates from the Kurdish region of Iran. The song reflects the intimate connection between people and the natural world, focusing on the beauty of natures, especially flowers.',
    },
    {
      videoLink: 'https://vimeo.com/1105197090?fl=pl&fe=vl',
      videoImage: bolandBaalaaImage,
      songTitle: 'Boland Baalaa',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Chaharshanbeh Suri',
        },
      ],
      songDescription: '"Boland Baalaa" ("Tall and Pretty") is a song from the Khorasan region in northeastern Iran. The song refers to the experience and feelings of being far away from a loved one, whether in spatial distance or emotional distance, reminding us how much someone can care for another person.',
    },
  ],
};
